// @flow
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'url-search-params-polyfill';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import 'typeface-roboto';

import { ThemeProvider } from '@material-ui/styles';
// eslint-disable-next-line
import MyZoidComponent from './widget/widget';
import App from './App';
import theme from './theme';
import { gaCode } from './config';

ReactGA.initialize('UA-103640126-4');

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>,
    rootElement
  );
}
